import { ACOUSTIC_CONTEXT_AUTH_STATUS } from './auth-status/auth.status';
import { ACOUSTIC_CONTEXT_COMPONENT_REGISTRY } from './component/component.registry';
import { ACOUSTIC_CONTEXT_COMPONENT_RESOLVER } from './component/component.resolver';
import { ACOUSTIC_CONTEXT_CONTENT_COMPONENT } from './component/content/content.component';
import { ACOUSTIC_CONTEXT_DEFAULT_COMPONENT } from './component/default/default.component';
import { ACOUSTIC_CONTEXT_PAGE_COMPONENT } from './component/page/page.component';
import {
  ACOUSTIC_CONTEXT_DELIVERY_CONTENT_RESOLVER,
  ACOUSTIC_CONTEXT_DELIVERY_CONTENT_SEED
} from './content/delivery.content.resolver';
import { ACOUSTIC_CONTEXT_HANDLEBARS_RESOLVER } from './handlebars/handlebars.resolver';
import {
  ACOUSTIC_CONTEXT_API_URL,
  ACOUSTIC_CONTEXT_BASE_URL,
  ACOUSTIC_CONTEXT_RESOURCE_URL,
  ACOUSTIC_CONTEXT_URL_CONFIG
} from './info/wch.info';
import {
  ACOUSTIC_CONTEXT_DELIVERY_LAYOUT_MAPPING_RESOLVER,
  ACOUSTIC_CONTEXT_DELIVERY_LAYOUT_MAPPING_SEED
} from './layout-mapping/delivery.layout.mapping.resolver';
import { ACOUSTIC_CONTEXT_LAYOUT_MAPPING_RESOLVER } from './layout-mapping/layout.mapping.resolver';
import {
  ACOUSTIC_CONTEXT_DELIVERY_LAYOUT_RESOLVER,
  ACOUSTIC_CONTEXT_DELIVERY_LAYOUT_SEED
} from './layout/delivery.layout.resolver';
import { ACOUSTIC_CONTEXT_LAYOUT_RESOLVER } from './layout/layout.resolver';
import {
  ACOUSTIC_CONTEXT_DYNAMIC_LOGGER_FACTORY,
  ACOUSTIC_CONTEXT_LOGGER_FACTORY,
  ACOUSTIC_CONTEXT_LOGGER_SERVICE
} from './logger/logger';
import {
  ACOUSTIC_CONTEXT_DELIVERY_PAGE_RESOLVER,
  ACOUSTIC_CONTEXT_DELIVERY_PAGE_SEED
} from './page/delivery.page.resolver';
import { ACOUSTIC_CONTEXT_PROTECTED_CONTENT } from './protected-content/protected.content';
import { ACOUSTIC_CONTEXT_RENDERING_CONTEXT_PROVIDER } from './rendering/rendering.context.provider';
import { ACOUSTIC_CONTEXT_RENDERING_CONTEXT_RESOLVER } from './rendering/rendering.context.resolver';
import { ACOUSTIC_CONTEXT_DELIVERY_SEARCH_RESOLVER } from './search/delivery.search.resolver';
import { ACOUSTIC_CONTEXT_RECONCILED_DELIVERY_SEARCH_RESOLVER } from './search/reconciled.delivery.search.resolver';
import { ACOUSTIC_CONTEXT_SEED_RESOLVER } from './seed/seed.resolver';
import { ACOUSTIC_CONTEXT_PAGE_SERVICE } from './services/page/wch.page.service';
import { ACOUSTIC_CONTEXT_WINDOW } from './services/window/window';
import { ACOUSTIC_CONTEXT_DELIVERY_SITE_RESOLVER } from './site/delivery.site.resolver';
import {
  ACOUSTIC_CONTEXT_DELIVERY_TYPE_RESOLVER,
  ACOUSTIC_CONTEXT_DELIVERY_TYPE_SEED
} from './type/delivery.type.resolver';
import { ACOUSTIC_CONTEXT_COMPONENT_TYPE_REF_RESOLVERS } from './type/type.ref.resolver';

/**
 * @deprecated use {@link ACOUSTIC_CONTEXT_LOGGER_FACTORY}  instead
 */
export const WCH_CONTEXT_LOGGER_FACTORY = ACOUSTIC_CONTEXT_LOGGER_FACTORY;
/**
 * @deprecated use {@link ACOUSTIC_CONTEXT_DELIVERY_CONTENT_SEED}  instead
 */
export const WCH_CONTEXT_DELIVERY_CONTENT_SEED = ACOUSTIC_CONTEXT_DELIVERY_CONTENT_SEED;
/**
 * @deprecated use {@link ACOUSTIC_CONTEXT_DELIVERY_LAYOUT_MAPPING_SEED}  instead
 */
export const WCH_CONTEXT_DELIVERY_LAYOUT_MAPPING_SEED = ACOUSTIC_CONTEXT_DELIVERY_LAYOUT_MAPPING_SEED;
/**
 * @deprecated use {@link ACOUSTIC_CONTEXT_DELIVERY_LAYOUT_SEED}  instead
 */
export const WCH_CONTEXT_DELIVERY_LAYOUT_SEED = ACOUSTIC_CONTEXT_DELIVERY_LAYOUT_SEED;
/**
 * @deprecated use {@link ACOUSTIC_CONTEXT_DELIVERY_PAGE_SEED}  instead
 */
export const WCH_CONTEXT_DELIVERY_PAGE_SEED = ACOUSTIC_CONTEXT_DELIVERY_PAGE_SEED;
/**
 * @deprecated use {@link ACOUSTIC_CONTEXT_DELIVERY_TYPE_SEED}  instead
 */
export const WCH_CONTEXT_DELIVERY_TYPE_SEED = ACOUSTIC_CONTEXT_DELIVERY_TYPE_SEED;
/**
 * @deprecated use {@link ACOUSTIC_CONTEXT_COMPONENT_RESOLVER}  instead
 */
export const WCH_CONTEXT_COMPONENT_RESOLVER = ACOUSTIC_CONTEXT_COMPONENT_RESOLVER;
/**
 * @deprecated use {@link ACOUSTIC_CONTEXT_DYNAMIC_LOGGER_FACTORY}  instead
 */
export const WCH_CONTEXT_DYNAMIC_LOGGER_FACTORY = ACOUSTIC_CONTEXT_DYNAMIC_LOGGER_FACTORY;
/**
 * @deprecated use {@link ACOUSTIC_CONTEXT_API_URL}  instead
 */
export const WCH_CONTEXT_API_URL = ACOUSTIC_CONTEXT_API_URL;
/**
 * @deprecated use {@link ACOUSTIC_CONTEXT_COMPONENT_REGISTRY}  instead
 */
export const WCH_CONTEXT_COMPONENT_REGISTRY = ACOUSTIC_CONTEXT_COMPONENT_REGISTRY;
/**
 * @deprecated use {@link ACOUSTIC_CONTEXT_LOGGER_SERVICE}  instead
 */
export const WCH_CONTEXT_LOGGER_SERVICE = ACOUSTIC_CONTEXT_LOGGER_SERVICE;
/**
 * @deprecated use {@link ACOUSTIC_CONTEXT_CONTENT_COMPONENT}  instead
 */
export const WCH_CONTEXT_CONTENT_COMPONENT = ACOUSTIC_CONTEXT_CONTENT_COMPONENT;
/**
 * @deprecated use {@link ACOUSTIC_CONTEXT_PAGE_SERVICE}  instead
 */
export const WCH_CONTEXT_PAGE_SERVICE = ACOUSTIC_CONTEXT_PAGE_SERVICE;
/**
 * @deprecated use {@link ACOUSTIC_CONTEXT_COMPONENT_TYPE_REF_RESOLVERS}  instead
 */
export const WCH_CONTEXT_COMPONENT_TYPE_REF_RESOLVERS = ACOUSTIC_CONTEXT_COMPONENT_TYPE_REF_RESOLVERS;
/**
 * @deprecated use {@link ACOUSTIC_CONTEXT_RESOURCE_URL}  instead
 */
export const WCH_CONTEXT_RESOURCE_URL = ACOUSTIC_CONTEXT_RESOURCE_URL;
/**
 * @deprecated use {@link ACOUSTIC_CONTEXT_BASE_URL}  instead
 */
export const WCH_CONTEXT_BASE_URL = ACOUSTIC_CONTEXT_BASE_URL;
/**
 * @deprecated use {@link ACOUSTIC_CONTEXT_WINDOW}  instead
 */
export const WCH_CONTEXT_WINDOW = ACOUSTIC_CONTEXT_WINDOW;
/**
 * @deprecated use {@link ACOUSTIC_CONTEXT_DEFAULT_COMPONENT}  instead
 */
export const WCH_CONTEXT_DEFAULT_COMPONENT = ACOUSTIC_CONTEXT_DEFAULT_COMPONENT;
/**
 * @deprecated use {@link ACOUSTIC_CONTEXT_PROTECTED_CONTENT}  instead
 */
export const WCH_CONTEXT_PROTECTED_CONTENT = ACOUSTIC_CONTEXT_PROTECTED_CONTENT;
/**
 * @deprecated use {@link ACOUSTIC_CONTEXT_RECONCILED_DELIVERY_SEARCH_RESOLVER}  instead
 */
export const WCH_CONTEXT_RECONCILED_DELIVERY_SEARCH_RESOLVER = ACOUSTIC_CONTEXT_RECONCILED_DELIVERY_SEARCH_RESOLVER;
/**
 * @deprecated use {@link ACOUSTIC_CONTEXT_AUTH_STATUS}  instead
 */
export const WCH_CONTEXT_AUTH_STATUS = ACOUSTIC_CONTEXT_AUTH_STATUS;
/**
 * @deprecated use {@link ACOUSTIC_CONTEXT_DELIVERY_CONTENT_RESOLVER}  instead
 */
export const WCH_CONTEXT_DELIVERY_CONTENT_RESOLVER = ACOUSTIC_CONTEXT_DELIVERY_CONTENT_RESOLVER;
/**
 * @deprecated use {@link ACOUSTIC_CONTEXT_DELIVERY_LAYOUT_MAPPING_RESOLVER}  instead
 */
export const WCH_CONTEXT_DELIVERY_LAYOUT_MAPPING_RESOLVER = ACOUSTIC_CONTEXT_DELIVERY_LAYOUT_MAPPING_RESOLVER;
/**
 * @deprecated use {@link ACOUSTIC_CONTEXT_DELIVERY_LAYOUT_RESOLVER}  instead
 */
export const WCH_CONTEXT_DELIVERY_LAYOUT_RESOLVER = ACOUSTIC_CONTEXT_DELIVERY_LAYOUT_RESOLVER;
/**
 * @deprecated use {@link ACOUSTIC_CONTEXT_DELIVERY_PAGE_RESOLVER}  instead
 */
export const WCH_CONTEXT_DELIVERY_PAGE_RESOLVER = ACOUSTIC_CONTEXT_DELIVERY_PAGE_RESOLVER;
/**
 * @deprecated use {@link ACOUSTIC_CONTEXT_DELIVERY_SEARCH_RESOLVER}  instead
 */
export const WCH_CONTEXT_DELIVERY_SEARCH_RESOLVER = ACOUSTIC_CONTEXT_DELIVERY_SEARCH_RESOLVER;
/**
 * @deprecated use {@link ACOUSTIC_CONTEXT_DELIVERY_SITE_RESOLVER}  instead
 */
export const WCH_CONTEXT_DELIVERY_SITE_RESOLVER = ACOUSTIC_CONTEXT_DELIVERY_SITE_RESOLVER;
/**
 * @deprecated use {@link ACOUSTIC_CONTEXT_DELIVERY_TYPE_RESOLVER}  instead
 */
export const WCH_CONTEXT_DELIVERY_TYPE_RESOLVER = ACOUSTIC_CONTEXT_DELIVERY_TYPE_RESOLVER;
/**
 * @deprecated use {@link ACOUSTIC_CONTEXT_HANDLEBARS_RESOLVER}  instead
 */
export const WCH_CONTEXT_HANDLEBARS_RESOLVER = ACOUSTIC_CONTEXT_HANDLEBARS_RESOLVER;
/**
 * @deprecated use {@link ACOUSTIC_CONTEXT_LAYOUT_MAPPING_RESOLVER}  instead
 */
export const WCH_CONTEXT_LAYOUT_MAPPING_RESOLVER = ACOUSTIC_CONTEXT_LAYOUT_MAPPING_RESOLVER;
/**
 * @deprecated use {@link ACOUSTIC_CONTEXT_LAYOUT_RESOLVER}  instead
 */
export const WCH_CONTEXT_LAYOUT_RESOLVER = ACOUSTIC_CONTEXT_LAYOUT_RESOLVER;
/**
 * @deprecated use {@link ACOUSTIC_CONTEXT_RENDERING_CONTEXT_PROVIDER}  instead
 */
export const WCH_CONTEXT_RENDERING_CONTEXT_PROVIDER = ACOUSTIC_CONTEXT_RENDERING_CONTEXT_PROVIDER;
/**
 * @deprecated use {@link ACOUSTIC_CONTEXT_RENDERING_CONTEXT_RESOLVER}  instead
 */
export const WCH_CONTEXT_RENDERING_CONTEXT_RESOLVER = ACOUSTIC_CONTEXT_RENDERING_CONTEXT_RESOLVER;
/**
 * @deprecated use {@link ACOUSTIC_CONTEXT_SEED_RESOLVER}  instead
 */
export const WCH_CONTEXT_SEED_RESOLVER = ACOUSTIC_CONTEXT_SEED_RESOLVER;
/**
 * @deprecated use {@link ACOUSTIC_CONTEXT_PAGE_COMPONENT}  instead
 */
export const WCH_CONTEXT_PAGE_COMPONENT = ACOUSTIC_CONTEXT_PAGE_COMPONENT;
/**
 * @deprecated use {@link ACOUSTIC_CONTEXT_URL_CONFIG}  instead
 */
export const WCH_CONTEXT_URL_CONFIG = ACOUSTIC_CONTEXT_URL_CONFIG;
